import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import DatePicker from 'react-datepicker';
import addComment from '../../../utils/addComment';
import addActivity from '../../../utils/addActivity';
import { fetchColaboradores, clearColaboradores } from '../../../actions';
import Paginacion from '../../../components/Paginacion';
import ErrorUIComponent from '../../../utils/ErrorUIComponent';
import Select from 'react-select';

import { FadeLoader } from 'react-spinners';
import moment from 'moment';

const COD_AUTORIZACIONES_EVENTO ="01";
const COD_PROFORMA_EVENTO = "02";
const COD_SOLICITUD_FACTURACION_EVENTO="03";
const COD_ESTADO_FDV_EVENTO ="04";
const COD_DESA_PEDIDO ="05";
const COD_COMENTARIO ="06";
const COD_ADJUNTOS ="07";
const COD_PEDIDOS_EVENTO ="08";
const COD_LAFIT ="09";
const COD_CAMBIO_CLIENTE="10";
const COD_ASIGNACION_PEDIDO="13";
const COD_DESASIGNACION_DEFINITIVA_PEDIDO_EVENTO="17";
const COD_DESASIGNACION_DEFINITIVA_FICHA_EVENTO="18";

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
  zIndex: '100',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const inputPropsActividad = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaboradorActividad',
};


const CustomCheckbox = props => (
  <div className='checkbox'>
    <label htmlFor={`checkbox-${props.cod}`} onClick={e => props.selectAndFetchTipoAgrupacion(e, props.cod)}>
      <input type='checkbox' id={`checkbox-${props.cod}`} checked={props.codTiAct === props.cod} />
      <div className='checkbox-skin' />
      {props.name}
    </label>
  </div>
);




class Historial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agregarComentario: false,
      asunto: '',
      codTiAct: '',
      comentario: '',
      newAnswer: '',
      responderComentario: false,
      respuesta: '',
      fechInicio: null,
      fechFinal: null,
      searchHistoryInput: '',
      searchHistorySelect: 'pedido',
      colaborador: '',
      colaboradores: [],
      eventos:[],
      muestraLoad:'',
      // paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      countPadres:0,
      //Actividad
      agregarActividad: false, 
      newAnswerActividad: '', 
      respuestaActividad: '', 
      colaboradoresActividad: [], 
      colaboradorActividad: '',
      comentarioActividad: '',
      comboActividad: '',
      listaTipoActividad: []
    };
  }

  onChangeValue = e => {
    console.log('e.target.value : ' + e.target.value);
    console.log('e.target.name : ' + e.target.name);

    let value ="";  value = e.target.value;
    this.setState({ [e.target.name]: value});
  }


  loading = (status) =>{

    this.setState({ muestraLoad: status });
  }

  componentDidMount() {

    const promises = [];
    this.loading('block')

    promises.push(this.props.fetchHistorialFDV(this.props.fdvID));
    promises.push(this.props.fetchTipoActividad());

    Promise.all(promises).then((result) => {
        console.log('data EVENTO : ' + result[0].payload.data.eventoResponse);
        console.log('data tipo actividad : ' + result[1].payload.data.listaTipoActividad);

        this.setState({eventos:result[0].payload.data.eventoResponse,
          totalRegistros:result[0].payload.data.cantidad,
          countPadres:result[0].payload.data.eventoResponse.length>10?result[0].payload.data.eventoResponse.length-10:0,
          cantidad:10,
          listaTipoActividad: result[1].payload.data.listaTipoActividad});
        this.loading('');
    }).catch(error => console.log(error));

  }

  // MBARDALES FECHA PASE 27/09/2021
  showAddActivity = () => this.setState({ agregarActividad: true, newAnswerActividad: '', respuestaActividad: '', colaboradoresActividad: [], colaboradorActividad: '' });
  // [F] MBARDALES FECHA PASE 27/09/2021

  showAddComment = () => this.setState({ agregarComentario: true, newAnswer: '', respuesta: '', colaboradores: [], colaborador: '' });
  handleChangeInicio = date => this.setState({ fechInicio: date });
  handleChangeFinal = date => this.setState({ fechFinal: date });
  openAnswerBox = (numEvento) => {
    this.hideComment();
    this.setState({ newAnswer: numEvento, respuesta: '' });
    //<I-87060> 
    const colaboradores = [];
    const destinatarios = this.state.eventos
      .filter(e => e.numEvento === numEvento)
      .map(d => d.destinatario)[0];
    if (typeof destinatarios !== 'undefined') {
      destinatarios.forEach(c => {
        const colaboradorExists = colaboradores
          .filter(colaborador => colaborador.id === c.idUsuario)
          .length > 0;
        if (!colaboradorExists) {
          const colaborador = {
            id: c.idUsuario,
            nombres: c.apellidos + ' ' + c.nombres
          };
          colaboradores.push(colaborador);
        }
      });
      this.setState({
        colaborador: '',
        colaboradores: colaboradores
      });
    }
    //<F-87060> 
  };
  closeAnswerBox = () => this.setState({ newAnswer: '', respuesta: '', colaboradores: [], colaborador: '' });

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  // PARA ACTIVIDAD MBARDALES FECHA PASE 27/09/2021
  changeColaboradorActividad = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  selectColaborador = (key) => {
    const { colaboradores } = this.state;
    const colaboradorSelected = colaboradores.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

      const apellidos = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };

      this.setState({ colaborador: '', colaboradores: [...this.state.colaboradores, colaborador] });
      this.props.clearColaboradores();
    }
  }

  // PARA ACTIVIDAD MBARDALES FECHA PASE 27/09/2021
  selectColaboradorActividad = (key) => {
    const { colaboradores } = this.state;
    const colaboradorSelected = colaboradores.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

      const apellidos = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };

      this.setState({ colaboradorActividad: '', colaboradoresActividad: [...this.state.colaboradoresActividad, colaborador] });
      this.props.clearColaboradores();
    }
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  removeColaborador = (id) => {
    const { colaboradores } = this.state;
    this.setState({ colaboradores: colaboradores.filter(colaborador => id !== colaborador.id) });
  }

  // PARA ACTIVIDAD MBARDALES FECHA PASE 27/09/2021
  removeColaboradorActividad = (id) => {
    console.log('idddd: ' + id);
    const { colaboradoresActividad } = this.state;
    this.setState({ colaboradoresActividad: colaboradoresActividad.filter(colaborador => id !== colaborador.id) });
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  answer = (eventoPadre, element) => {

    console.log('element',element);
    console.log('element',element);

    const { fdvID } = this.props;
    const { respuesta } = this.state;
    if (respuesta.trim()) {
        addComment(fdvID, element.asunto, respuesta, eventoPadre,'00',this.state.colaboradores.map((item) =>  item.id))
        .then(({ data }) => {
            this.componentDidMount();
            this.closeAnswerBox();
            this.props.openAlert(data);
        });
    }
  }

  comment = () => {

    const { fdvID } = this.props;
    const { asunto, comentario } = this.state;
    if (asunto.trim() && comentario.trim()) {
      addComment(fdvID, asunto, comentario,'','00',this.state.colaboradores.map((item) =>  item.id))
      .then(({ data }) => {
        this.props.openAlert(data);
        this.setState({ codTiAct: '00' });
        this.props.fetchHistorialFDV(fdvID);
        this.hideComment();
        this.componentDidMount();
      });
    }
  }

  // PARA ACTIVIDAD MBARDALES FECHA PASE 27/09/2021
  actividad = () => {

    const { fdvID } = this.props;
    const { comboActividad, comentarioActividad } = this.state;
    let actividad = this.state.listaTipoActividad.filter(x => x.idMaeActividad == comboActividad);
    let asuntoActividad = 'Actividad ' + actividad[0].descMaeActividad;
    let idProceso = '1';
    console.log(asuntoActividad.trim());
    console.log(this.state.colaboradoresActividad);
    
    if (asuntoActividad.trim()) {
      addActivity(fdvID, idProceso, comboActividad, asuntoActividad, comentarioActividad,'','00',this.state.colaboradoresActividad.map((item) =>  item.id))
      .then(({ data }) => {
        this.props.openAlert(data);
        this.setState({ codTiAct: '00' });
        this.props.fetchHistorialFDV(fdvID);
        this.hideActivity();
        this.componentDidMount();
      });
    }
    
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  hideComment = () => {
    this.setState({
      agregarComentario: false,
      asunto: '',
      comentario: '',
      colaboradores: [],
      colaborador: '',
    });
  }

  // PARA ACTIVIDAD [I] MBARDALES FECHA PASE 27/09/2021
  hideActivity = () => {
    this.setState({
      agregarActividad: false,
      asunto: '',
      comentarioActividad: '',
      colaboradoresActividad: [],
      colaboradorActividad: '',
      comboActividad: ''
    });
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  // PARA COMBO ACTIVIDAD MBARDALES FECHA PASE 27/09/2021
  changeComboActividad = e => {
    console.log('e : ' + [e.target.name]);
    console.log('e : ' + e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }
  // [F] MBARDALES FECHA PASE 27/09/2021

  selectAndFetchTipoAgrupacion = (e, cod) => {
    e.preventDefault();
    const { codTiAct } = this.state;

    if (codTiAct === cod) {
      this.setState({ codTiAct: '' }, () => this.searchEvents());
    } else {
      this.setState({ codTiAct: cod }, () => this.searchEvents());
    }
    this.closeAnswerBox();
  }

  searchEvents = () => {

    this.loading('block')
    const { fdvID } = this.props;
    const { fechInicio, fechFinal, searchHistorySelect, searchHistoryInput , codTiAct  } = this.state;
    const fechaInicio = fechInicio === null ? '' : fechInicio.format('DD/MM/YYYY');
    const fechaFinal = fechFinal === null ? '' : fechFinal.format('DD/MM/YYYY');


    this.props.fetchHistorialFDV(
      fdvID,
      fechaInicio,
      fechaFinal,
      searchHistorySelect==='pedido'?searchHistoryInput:'',
      searchHistorySelect==='proforma'?searchHistoryInput:'',
      codTiAct
    ).then(result =>{
      this.setState({eventos:result.payload.data.eventoResponse})
      this.loading('')
    });
  }

  backPag = () => {
    if (this.state.pagina === 1) return;
    this.setState(
      { pagina: this.state.pagina - 1 },
      () => {
        const { pagina } = this.state;
        this.functionPaginacion(pagina);
      }
    );
  }

  nextPag = () => {
    if (this.state.pagina * 10 > this.state.totalRegistros) return;
    this.setState(
      { pagina: this.state.pagina + 1 },
      () => {
        const { pagina } = this.state;
        this.functionPaginacion(pagina);
      }
    );
  }

 printcontent = (content)=>
  {
      return {__html:content};
  }

  functionPaginacion = (pagina)=> {
    this.loading('block');

    const { fdvID } = this.props;
    const { fechInicio, fechFinal, searchHistorySelect, searchHistoryInput  } = this.state;
    const fechaInicio = fechInicio === null ? '' : fechInicio.format('DD/MM/YYYY');
    const fechaFinal = fechFinal === null ? '' : fechFinal.format('DD/MM/YYYY');

    this.props.fetchHistorialFDV(
      fdvID,
      fechaInicio,
      fechaFinal,
      searchHistorySelect==='pedido'?searchHistoryInput:'',
      searchHistorySelect==='proforma'?searchHistoryInput:'',
      '',
      pagina
    ).then(result =>{
      this.setState({eventos:result.payload.data.eventoResponse,
        totalRegistros: result.payload.data.cantidad,
        cantidad: result.payload.data.eventoResponse.length - this.state.countPadres,
      });
      this.loading('');
    });
  }


  renderComentarioHijo(evento,nuevoPadre,nivel,count){

    let nuevaLista =[];

      if(nivel === 1){
        //90000 <I> ecubas 28/04
        nuevaLista = evento.filter((x)=>x.numEventoPadre.split('.').length >= 2);
        //90000 <F> ecubas 28/04
        return(
          nuevaLista.map(element => (
          <li class="card card-plain card-lg fdv-hist-event"><i class="fdv-hist-event-icon ion-checkmark-circled"></i>
              <div class="fdv-hist-event-head">
                <h5 class="fdv-hist-event-title">{element.asunto}</h5>
                <p class="subInfo">{element.usuario} el {moment(element.fecha).format('DD/MM/YYYY HH:mm')}</p>
              </div>

              <p class="mb-0"><span class="mr-2" dangerouslySetInnerHTML={this.printcontent(element.comentario)}></span></p>

              <div className='fdv-hist-actions'>
                <button
                  className='c-cyan btn btn-clean'
                  onClick={() => this.openAnswerBox(element.numEvento)}
                                  >
                  Responder comentario
                </button>

                <div className='btn-iconLeft'>
                  <i className='ion-android-textsms h6' />
                  {
                    this.state.eventos.filter((item) => item.numEventoPadre === element.numEvento).length
                  } respuesta(s)
                </div>
              </div>

              <div className={`comment ${ element.numEvento === this.state.newAnswer ? '' : 'js-hide'}`} id='coment2'>
                <div className='form-group comment-textarea'>
                  <div className='form-group'>
                    <label htmlFor={this.state.numEvento}>Nuevo comentario</label>
                    <textarea
                      className='form-control'
                      name='respuesta'
                      value={this.state.respuesta}
                      onChange={this.onChangeValue}
                      maxLength='2000'
                    />
                  </div>
                </div>
                <div className='row form-group'>
                  <div className='col-sm-6'>
                    <div className='pillSelct'>
                      <p className='labelInfo'>Notifica a un colaborador</p>
                      <div className='pillSelct-field'>
                        <div className='awesomplete'>
                          <Autocomplete
                            getItemValue={item => item.idUsuario.toString()}
                            value={this.state.colaborador}
                            items={this.props.colaboradores}
                            renderItem={(item, isHighlighted) =>
                              <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                {`${item.apellidos} ${item.nombre}`}
                              </div>
                            }
                            onChange={this.changeColaborador}
                            menuStyle={menuStyle}
                            inputProps={inputProps}
                            wrapperStyle={{ display: 'block' }}
                            onSelect={this.selectColaborador}
                          />
                        </div>
                        <div className='pillSelct-pills'>
                          {
                            this.state.colaboradores.map(colaborador => (
                              <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                                {colaborador.nombres}
                                <button
                                  className='pillSelct-delete'
                                  onClick={() => this.removeColaborador(colaborador.id)}
                                ><i className='icon ion-close pill-close' />
                                </button>
                              </label>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </div>
      </div>
      <div className='btnActions'>
        <button
          className='btn btn-secondary'
          onClick={() => this.closeAnswerBox()}
        >
        Cancelar
      </button>
        <button
          className='btn btn-primary'
          hideparent='.comment'
          onClick={() => this.answer(element.numEvento,element)}
        >
          Comentar
        </button>
      </div>
                </div>

               {
                 this.renderComentarioHijo(evento.filter((x)=>x.numEventoPadre !== nuevoPadre),element.numEvento,nivel+1)
               }

          </li>
          )));
      }

      if(nivel>1){

        nuevaLista = evento.filter((x)=>x.numEventoPadre === nuevoPadre);


        return(
          nuevaLista.map(element => (
           <div className='fdv-hist-event-padre'>
            <div className='fdv-hist-event-nuevo' key={element.numEvento}>
               <p dangerouslySetInnerHTML={this.printcontent(element.comentario)}></p>

               <p className='subInfo'>{element.usuario} el {moment(element.fecha).format('DD/MM/YYYY HH:mm')}</p>
               <div className='fdv-hist-actions'>
                <button
                  className='c-cyan btn btn-clean'
                  onClick={() => this.openAnswerBox(element.numEvento)}
                                  >
                  Responder comentario
                </button>

                <div className='btn-iconLeft'>
                  <i className='ion-android-textsms h6' />
                  {                   this.state.eventos.filter((item) => item.numEventoPadre === element.numEvento).length

                  } respuesta(s)
                </div>
              </div>
              <div className={`comment ${ element.numEvento === this.state.newAnswer ? '' : 'js-hide'}`} id='coment2'>
                <div className='form-group comment-textarea'>
                  <div className='form-group'>
                    <label htmlFor={this.state.numEvento}>Nuevo comentario</label>
                    <textarea
                      className='form-control'
                      name='respuesta'
                      value={this.state.respuesta}
                      onChange={this.onChangeValue}
                      maxLength='2000'
                    />
                  </div>
                </div>
                <div className='row form-group'>
        <div className='col-sm-6'>
          <div className='pillSelct'>
            <p className='labelInfo'>Notifica a un colaborador</p>
            <div className='pillSelct-field'>
              <div className='awesomplete'>
                <Autocomplete
                  getItemValue={item => item.idUsuario.toString()}
                  value={this.state.colaborador}
                  items={this.props.colaboradores}
                  renderItem={(item, isHighlighted) =>
                    <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                      {`${item.apellidos} ${item.nombre}`}
                    </div>
                  }
                  onChange={this.changeColaborador}
                  menuStyle={menuStyle}
                  inputProps={inputProps}
                  wrapperStyle={{ display: 'block' }}
                  onSelect={this.selectColaborador}
                />
              </div>
              <div className='pillSelct-pills'>
                {
                  this.state.colaboradores.map(colaborador => (
                    <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                      {colaborador.nombres}
                      <button
                        className='pillSelct-delete'
                        onClick={() => this.removeColaborador(colaborador.id)}
                      ><i className='icon ion-close pill-close' />
                      </button>
                    </label>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='btnActions'>
        <button
          className='btn btn-secondary'
          onClick={() => this.closeAnswerBox()}
        >
        Cancelar
      </button>
        <button
          className='btn btn-primary'
          hideparent='.comment'
          onClick={() => this.answer(element.numEvento,element)}
        >
          Comentar
        </button>
      </div>
                </div>

             </div>
              {
                this.renderComentarioHijo(evento.filter((x)=>x.numEventoPadre !== nuevoPadre).sort(function (a, b) {
                  if (a.numEvento < b.numEvento) {
                    return 1;
                  }
                  if (a.numEvento > b.numEvento) {
                    return -1;
                  }
                  return 0;}),element.numEvento,nivel+1)
               }


            </div>
        )));

      }
}



  render() {
    return (
      <ErrorUIComponent>

      <section className='fdv-section' id='historial'>
        <header className='fdv-section-head'>
          <h5 className='fdv-section-title'>Historial de ficha de venta</h5>
          
          <div className='fdv-section-actions'>
            <button
              className='btn btn-primary'
              onClick={(e) => this.showAddActivity()}
            >
              Agregar actividad
            </button>
            &nbsp;
            &nbsp;
            <button
              className='btn btn-primary'
              onClick={(e) => this.props.handlePermissions(e) && this.showAddComment()}
              data-permisos='ind_agregar_comentario'
            >
              Agregar comentario
            </button>
          </div>
        </header>

        {/* PARA ACTIVIDAD [I] MBARDALES FECHA PASE 27/09/2021*/}
        <div className={`comment card card-lg card-plain ${this.state.agregarActividad ? '' : 'js-hide'}`}>
          <div className='form-group'>
            <label htmlFor='subject' className='labelInfo'>Actividad</label>
            {/*<input
              id='subject'
              className='form-control'
              name='asunto'
              onChange={this.onChangeValue}
              value={this.state.asunto}
            />*/}
            <div className="select">
              <select className='form-control' id='comboActividad' name='comboActividad'
                value={this.state.comboActividad} onChange={this.changeComboActividad} >
                <option value="">Seleccionar Actividad</option>
                {
                  this.state.listaTipoActividad.map(actividad => (
                    <option key={actividad.idMaeActividad} value={actividad.idMaeActividad}>
                      {actividad.descMaeActividad}
                    </option>
                  ))
                }
              </select>
              <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
            </div>
              
          </div>

          <div className='form-group comment-textarea'>
            <div className='form-group'>
              <label htmlFor='new-comment-activity'>Nuevo comentario</label>
              <textarea
                id='new-comment-activity'
                className='form-control'
                name='comentarioActividad'
                onChange={this.onChangeValue}
                value={this.state.comentarioActividad}
                maxLength='2000'
              />
            </div>
          </div>

          <div className='row form-group'>
            <div className='col-sm-6'>
              <div className='pillSelct'>
                <p className='labelInfo'>Notifica a un colaborador</p>
                <div className='pillSelct-field'>
                  <div className='awesomplete'>
                    <Autocomplete
                      getItemValue={item => item.idUsuario.toString()}
                      value={this.state.colaboradorActividad}
                      items={this.props.colaboradores}
                      renderItem={(item, isHighlighted) =>
                        <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                          {`${item.apellidos} ${item.nombre}`}
                        </div>
                      }
                      onChange={this.changeColaboradorActividad}
                      menuStyle={menuStyle}
                      inputProps={inputPropsActividad}
                      wrapperStyle={{ display: 'block' }}
                      onSelect={this.selectColaboradorActividad}
                    />
                  </div>
                  <div className='pillSelct-pills'>
                    {
                      this.state.colaboradoresActividad.map(colaborador => (
                        <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                          {colaborador.nombres}
                          <button
                            className='pillSelct-delete'
                            onClick={() => this.removeColaboradorActividad(colaborador.id)}
                          ><i className='icon ion-close pill-close' />
                          </button>
                        </label>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='btnActions'>
            <button className='btn btn-return' onClick={this.hideActivity}>Cancelar</button>
            <button className='btn btn-primary' onClick={this.actividad}>Agregar</button>
          </div>
        </div>
        {/* [F] MBARDALES FECHA PASE 27/09/2021*/}

        <div className={`comment card card-lg card-plain ${this.state.agregarComentario ? '' : 'js-hide'}`}>
          <div className='form-group'>
            <label htmlFor='subject' className='labelInfo'>Asuntos</label>
            <input
              id='subject'
              className='form-control'
              name='asunto'
              onChange={this.onChangeValue}
              value={this.state.asunto}
            />
          </div>
          <div className='form-group comment-textarea'>
            <div className='form-group'>
              <label htmlFor='new-comment'>Nuevo comentario</label>
              <textarea
                id='new-comment'
                className='form-control'
                name='comentario'
                onChange={this.onChangeValue}
                value={this.state.comentario}
                maxLength='2000'
              />
            </div>

            {/* <label className='c-cyan file' htmlFor='f1'>
              <i className='h5 ion-paperclip mr-2' />
              Adjuntar archivo
            </label>
            <input type='file' style={{ display: 'none' }} id='f1' /> */}

          </div>
          <div className='row form-group'>
            <div className='col-sm-6'>
              <div className='pillSelct'>
                <p className='labelInfo'>Notifica a un colaborador</p>
                <div className='pillSelct-field'>
                  <div className='awesomplete'>
                    <Autocomplete
                      getItemValue={item => item.idUsuario.toString()}
                      value={this.state.colaborador}
                      items={this.props.colaboradores}
                      renderItem={(item, isHighlighted) =>
                        <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                          {`${item.apellidos} ${item.nombre}`}
                        </div>
                      }
                      onChange={this.changeColaborador}
                      menuStyle={menuStyle}
                      inputProps={inputProps}
                      wrapperStyle={{ display: 'block' }}
                      onSelect={this.selectColaborador}
                    />
                  </div>
                  <div className='pillSelct-pills'>
                    {
                      this.state.colaboradores.map(colaborador => (
                        <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                          {colaborador.nombres}
                          <button
                            className='pillSelct-delete'
                            onClick={() => this.removeColaborador(colaborador.id)}
                          ><i className='icon ion-close pill-close' />
                          </button>
                        </label>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='btnActions'>
            <button className='btn btn-return' onClick={this.hideComment}>Cancelar</button>
            <button className='btn btn-primary' onClick={this.comment}>Comentar</button>
          </div>
        </div>
        <div className='row row-vCenter mb-2'>
          <div className='col-sm-2'>
            <p className='labelInfo'>Filtrar por</p>
          </div>
          <div className='col-sm-3'>
            <div className='fSearch'>
              <DatePicker
                selected={this.state.fechInicio}
                className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched'
                dateFormat='DD/MM/YYYY'
                locale='es'
                onChange={this.handleChangeInicio}
                placeholderText='F. Inicio'
              />
              <DatePicker
                selected={this.state.fechFinal}
                className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched'
                dateFormat='DD/MM/YYYY'
                onChange={this.handleChangeFinal}
                placeholderText='F. Fin'
              />
              <button
                className='btn btn-dark fSearch-go'
                onClick={this.searchEvents}
              >
                <i className='ion-android-arrow-forward' />
              </button>
            </div>
          </div>
          <div className='col-sm-4'>
            <div className='fSearch'>
              <div className='fSearch-filter form-control'>
                <select value={this.state.searchHistorySelect} onChange={this.onChangeValue} className='searchOption' name='searchHistorySelect'>
                  <option value='pedido'>Nro Pedido</option>
                  <option value='proforma'>Nro Proforma</option>
                </select>
              </div>
              <input
                type='text'
                name='searchHistoryInput'
                className='fSearch-search form-control'
                placeholder='Ingrese el dato seleccionado'
                value={this.state.searchHistoryInput}
                onChange={this.onChangeValue}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.searchEvents();
                  }
                }}
              />
              <button
                className='btn btn-dark fSearch-go'
                type='button'
                onClick={this.searchEvents}
              >
                <i className='ion-android-arrow-forward' />
              </button>
            </div>
          </div>
          <div className='col-sm-3'>
            <div className='dropdown dropdown-multi customToggle' id='agrupacion'>
              <div className='dropdown-control'>
                <input className='dropdown-control-input' placeholder='Tipo de agrupación' />
                <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
              </div>
              <div className='dropdown-tooltip dropdown-menu'>
                <div className='dropdown-scroll'>
                  <ul>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_ESTADO_FDV_EVENTO}
                        codTiAct={this.state.codTiAct}
                        name='Estado de FDV'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_SOLICITUD_FACTURACION_EVENTO}
                        codTiAct={this.state.codTiAct}
                        name='Solicitud de Facturación'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_PROFORMA_EVENTO}
                        codTiAct={this.state.codTiAct}
                        name='Desasignación de proforma'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_ADJUNTOS}
                        codTiAct={this.state.codTiAct}
                        name='Archivos adjuntos'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_DESASIGNACION_DEFINITIVA_PEDIDO_EVENTO}
                        codTiAct={this.state.codTiAct}
                        name='Desasignación de Definitiva del pedido'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_DESASIGNACION_DEFINITIVA_FICHA_EVENTO}
                        codTiAct={this.state.codTiAct}
                        name='Designación del pedido de la Ficha'
                      />
                    </li>
                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_LAFIT}
                        codTiAct={this.state.codTiAct}
                        name='Envio LAFIT'
                      />
                    </li>

                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_CAMBIO_CLIENTE}
                        codTiAct={this.state.codTiAct}
                        name='Cambiar cliente'
                      />
                    </li>

                    <li>
                      <CustomCheckbox
                        selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
                        cod={COD_ASIGNACION_PEDIDO}
                        codTiAct={this.state.codTiAct}
                        name='Asignación Definitiva'
                      />
                    </li>



                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-sm-3'>
            <CustomCheckbox
              selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
              cod={COD_COMENTARIO}
              codTiAct={this.state.codTiAct}
              name='Comentarios'
            />
          </div>
          <div className='col-sm-3'>
            <CustomCheckbox
              selectAndFetchTipoAgrupacion={this.selectAndFetchTipoAgrupacion}
              cod={COD_AUTORIZACIONES_EVENTO}
              codTiAct={this.state.codTiAct}
              name='Autoriz. Excepcion.'
            />
          </div>
          <Paginacion
               paginas={this.state.totalRegistros}
               pagina={this.state.pagina}
               cantidad={this.state.cantidad}
               backPag={this.backPag}
               nextPag={this.nextPag}
          />
        </div>
        <ul>
          {
            this.renderComentarioHijo(this.state.eventos,this.props.eventoPadre,1)
          }
        </ul>
        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      </section>
      </ErrorUIComponent>

    );
  }
}

Historial.defaultProps = {
  eventos: [],
};

function mapStateToProps(state) {
  return {
    colaboradores: state.colaboradores,
  };
}

export default connect(mapStateToProps, { fetchColaboradores, clearColaboradores })(Historial);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Historial.js